// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardBox {
  display: flex;
  flex-direction: column;
  min-height: 150px;
  width: auto;
  max-width: 95%;
  padding: 10px;
  background-color: white;
  margin-left: 20px;
  margin-top: 5px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dashboardInnerBox {
  display: flex;
  align-items: center;
  margin-top: 1px;
  height: 30px;
  font-style: italic;
  color: black;
  font-size: 14px;
}

.dashboardDropDownContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 5px;
  width: 100%;
}

.refresh-button {
  margin-left: 10px;
  width: 60px;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.innerdropdown {
  margin-left: 10px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.charts-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
}

.chart-section {
  text-align: center;
  min-width: 250px;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chart-section h3 {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.chart-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-bg-button {
  background-color: transparent !important;
  border: none !important;
  color: #007bff !important; /* or whatever color you want */
}

/* Table container responsive styles for consistent display across resolutions */
.table-container {
  flex: 1 1;
  position: relative;
  height: auto;
  overflow: auto;
  margin-top: -10px;
}

.table-container .data-table-container {
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA,gFAAgF;AAChF;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".dashboardBox {\n  display: flex;\n  flex-direction: column;\n  min-height: 150px;\n  width: auto;\n  max-width: 95%;\n  padding: 10px;\n  background-color: white;\n  margin-left: 20px;\n  margin-top: 5px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dashboardInnerBox {\n  display: flex;\n  align-items: center;\n  margin-top: 1px;\n  height: 30px;\n  font-style: italic;\n  color: black;\n  font-size: 14px;\n}\n\n.dashboardDropDownContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n.refresh-button {\n  margin-left: 10px;\n  width: 60px;\n}\n\n.center-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.innerdropdown {\n  margin-left: 10px;\n  padding: 4px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.charts-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.chart-section {\n  text-align: center;\n  min-width: 250px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.chart-section h3 {\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n}\n\n.chart-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.no-bg-button {\n  background-color: transparent !important;\n  border: none !important;\n  color: #007bff !important; /* or whatever color you want */\n}\n\n/* Table container responsive styles for consistent display across resolutions */\n.table-container {\n  flex: 1;\n  position: relative;\n  height: auto;\n  overflow: auto;\n  margin-top: -10px;\n}\n\n.table-container .data-table-container {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
